export const driftDirections = [
    { dx: 1, dy: 0 }, // Right
    { dx: -1, dy: 0 }, // Left
    { dx: 0, dy: -1 }, // Up
    { dx: 0, dy: 1 }, // Down
    { dx: 1, dy: -1 }, // Up-right
    { dx: -1, dy: 1 }, // Down-left
];